// import ProfilePage from './ProfilePage';
// export default ProfilePage;

import MobileProfilePage from './MobileProfilePage';
export default MobileProfilePage;
